import { useState } from "react";
import { api, fmtErr } from "../../lib/api";
import { toast } from "sonner";
import { Megaphone, Send } from "lucide-react";

export default function AdminPush() {
  const [title, setTitle] = useState("Due novità ti aspettano in Arcana ✨");
  const [body, setBody] = useState("Scopri la nuova Stesa 26 e lasciati guidare dal rinnovato Oracolo del Destino. Due esperienze di consultazione ti aspettano: apri Arcana e provale!");
  const [link, setLink] = useState("/");
  const [sending, setSending] = useState(false);
  const [result, setResult] = useState(null);

  const send = async () => {
    if (!window.confirm(`Inviare la notifica a TUTTI gli utenti registrati?\n\nTitolo: ${title}\n\n${body}`)) return;
    setSending(true);
    setResult(null);
    try {
      const r = await api.post("/admin/push/broadcast", { title, body, link });
      setResult(r.data);
      toast.success("Notifica inviata.");
    } catch (e) {
      toast.error(fmtErr(e));
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="mystic-card p-6 sm:p-8 max-w-2xl space-y-5" data-testid="admin-push-panel">
      <div className="flex items-center gap-3">
        <Megaphone className="w-5 h-5 text-amber-300" />
        <div>
          <h2 className="font-display text-xl text-amber-100">Notifica push a tutti gli utenti</h2>
          <p className="text-xs text-purple-300/60 mt-1">
            Invia una notifica push ai dispositivi registrati e un avviso nella campanella in-app di ogni utente.
            L'invio è immediato e non annullabile.
          </p>
        </div>
      </div>
      <div>
        <label className="text-xs text-purple-300/70 block mb-1">Titolo</label>
        <input className="input-dark w-full" value={title} maxLength={120} onChange={(e) => setTitle(e.target.value)} data-testid="admin-push-title-input" />
      </div>
      <div>
        <label className="text-xs text-purple-300/70 block mb-1">Messaggio</label>
        <textarea className="input-dark w-full min-h-[110px] resize-y" value={body} maxLength={400} onChange={(e) => setBody(e.target.value)} data-testid="admin-push-body-input" />
      </div>
      <div>
        <label className="text-xs text-purple-300/70 block mb-1">Link all'apertura (opzionale)</label>
        <input className="input-dark w-full" value={link} maxLength={200} onChange={(e) => setLink(e.target.value)} data-testid="admin-push-link-input" />
      </div>
      <button onClick={send} disabled={sending || !title.trim() || !body.trim()} className="gold-btn px-6 py-2.5 text-sm flex items-center gap-2 disabled:opacity-50" data-testid="admin-push-send-btn">
        <Send className="w-4 h-4" /> {sending ? "Invio in corso…" : "Invia notifica a tutti"}
      </button>
      {result && (
        <p className="text-xs text-emerald-300/80" data-testid="admin-push-result">
          Inviata: {result.tokens} dispositivi push, {result.notified_users} utenti avvisati in-app
          {result.fcm_sent ? "" : " (push FCM non partita: nessun dispositivo registrato o configurazione mancante)"}.
        </p>
      )}
    </div>
  );
}
